<template>
  <div class="d-fx ai-c">
    <i class="icon-bell f-20px mt-_2px cursor-pointer" @click="toggleNotification"></i>
    <i class="icon-search f-22px mt-_2px ml-10px cursor-pointer" @click="toggleSearch"></i>
  </div>
</template>

<script>
import {mapStateVModel} from 'map-state-vmodel';

export default {
  name: 'signedC',
  extends: {},
  props: {},
  data(){
    return{};
  },
  components: {},
  computed: {
    ...mapStateVModel('header', ['searchBox', 'notification']),
  },
  watch: {},
  methods: {
    toggleNotification() {
      this.notification = !this.notification      
    },
    toggleSearch() {
      this.searchBox = !this.searchBox
    }
  },
  beforeCreate(){},
  mounted(){}
}
</script>
